import { useState, useRef } from "react";
import useCheckClickOutside from "../../../../../../../../../hooks/useCheckClickOutside";

const AdditionalTermInput = (props) => {
  const { inputDetailItem, value, handleInputChange } = props;

  const { source, label, desc, subLabel, ExpandedDescription } =
    inputDetailItem;

  const [expandDesc, setExpandDesc] = useState(false);
  const descRef = useRef();

  useCheckClickOutside(descRef, () => setExpandDesc(false));

  const isGoldenItem = source === "amazonSuggestedSearch";

  return (
    <section className="term-input-section-container">
      <div
        className={`term-input-additional-info ${
          isGoldenItem ? "golden-input" : ""
        }`}
      >
        <div className="term-input-header">
          <label htmlFor={source}>{label}</label>
          <div
            className={`hover-info-icon-container ${
              isGoldenItem ? "dark" : "light"
            }`}
            onClick={() => setExpandDesc((old) => !old)}
          >
            <p className="question-mark-icon">?</p>
          </div>
        </div>
        <div className="input-source-description-container">
          <div>
            <p>{subLabel}</p>
          </div>
          <div
            ref={descRef}
            className={`input-source-description ${
              expandDesc ? "expand-desc" : ""
            }`}
          >
            <div className="input-desc-detail-header">
              {/* <p>
                <b>{label}</b>
              </p> */}
              <p>{subLabel}</p>
            </div>

            {ExpandedDescription}
          </div>
        </div>
        {/* <p className={`input-source-description ${expandDesc ? 'expand-desc' : ''}`} id={expandDesc ? backgroundId : null}>
                    {desc}
                </p> */}
      </div>
      <div className="term-input-user-input">
        <textarea
          id={source}
          value={value}
          name={source}
          onChange={handleInputChange}
          placeholder="Enter keywords here..."
        />
      </div>
    </section>
  );
};

export default AdditionalTermInput;
